"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactIntl = require("react-intl");
var messages = (0, _reactIntl.defineMessages)({
  ssoLogin: {
    "id": "ssoLogin",
    "defaultMessage": "Company account"
  },
  emailAndPasswordLogin: {
    "id": "emailAndPasswordLogin",
    "defaultMessage": "Email"
  },
  phoneNumber: {
    "id": "common.forms.phoneNumber",
    "defaultMessage": "Phone Number"
  },
  domainPasswordLogin: {
    "id": "domainPasswordLogin",
    "defaultMessage": "Workspace password"
  },
  formAction_iHaveAnAdminAccount: {
    "id": "formAction_iHaveAnAdminAccount",
    "defaultMessage": "I have an admin account"
  },
  formAction_iHaveAnActivationCode: {
    "id": "formAction_iHaveAnActivationCode",
    "defaultMessage": "I have an activation code"
  }
});
var _default = exports["default"] = messages;
//# sourceMappingURL=messages.js.map